import script from "./NavigationControls.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationControls.vue?vue&type=script&setup=true&lang=js"

import "./NavigationControls.vue?vue&type=style&index=0&id=4fdaf992&scoped=true&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fdaf992"]])

export default __exports__